export default __webpack_public_path__ + "static/media/service1.5e663936.webp";